import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { cn } from "../../lib/utils";
import { SLIDER_STYLES } from "./constants";
import { SliderProps } from "./types";

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  SliderProps
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(SLIDER_STYLES.root, className)}
    {...props}
  >
    <SliderPrimitive.Track className={SLIDER_STYLES.track}>
      <SliderPrimitive.Range className={SLIDER_STYLES.range} />
    </SliderPrimitive.Track>
    {(props.value || props.defaultValue)?.map((_: number, index: number) => (
      <SliderPrimitive.Thumb
        key={index}
        className={SLIDER_STYLES.thumb}
      />
    ))}
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
